import React from 'react';
import { TableProps } from '@ui';
import type { Full } from 'types/common';
import type { IUserProviderItem } from 'types/provider.types';
import type { ColumnWithLooseAccessor } from 'react-table';
import ProviderStatus from './components/provider-status';
import PairingStatus from './components/pairing-status';
import { useIntl } from 'react-intl';

export type TTable = Full<TableProps<IUserProviderItem>>;
type TTableCol = ColumnWithLooseAccessor<IUserProviderItem>;

export function useTableColumns() {
  const { formatMessage } = useIntl();

  return React.useMemo<TTableCol[]>(
    () => [
      {
        Header: 'Názov',
        id: 'name',
        Cell: ({ row: { original } }) => {
          return <>{`${original.provider.name}`}</>;
        },
      },
      {
        Header: 'Adresa',
        id: 'address',
        Cell: ({ row: { original } }) => {
          return (
            <>{`${original.provider.address.address}, ${original.provider.address.postCode} ${original.provider.address.city}, ${original.provider.address.country}`}</>
          );
        },
      },
      {
        Header: 'Rola',
        id: 'role',
        Cell: ({ row: { original } }) => {
          return <>{`${formatMessage({ id: `business_staff_role_${original.role.name}` })}`}</>;
        },
      },
      {
        Header: 'Stav poskytovatela',
        id: 'status',
        Cell: ({ row: { original } }) => {
          return <ProviderStatus status={original.provider.status} />;
        },
      },
      {
        Header: 'Stav párovania',
        id: 'PairingStatus',
        Cell: ({ row: { original } }) => {
          return <PairingStatus status={original.status} />;
        },
      },
    ],
    [],
  );
}
